export const URL_USERS_SEARCH = '/users/search';
export const GET_SEARCH_GLOBAL_DATA = 'users/search-global';
export const GET_SEARCH_GROUP_PROJECTS_DATA = '/groups/autocomplete/:id';
export const GET_USERS_ME = '/users/me';
export const GET_SEARCH_GROUP_DATA = '/groups/projects'; 